(function () {
  var cartChangeUrl = (window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.cartChangeUrl) || '/cart/change';
  var isCartPage = window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType === 'cart';

  function buildNestedMap(container) {
    var map = new Map();
    var children = container.querySelectorAll('[data-parent-key]');
    children.forEach(function (child) {
      var parentKey = child.getAttribute('data-parent-key');
      var childKey = child.getAttribute('data-line-key');
      var childMin = parseInt(child.getAttribute('data-child-quantity-min'), 10) || 1;
      if (parentKey && childKey) {
        map.set(parentKey, { childKey: childKey, childMin: childMin });
      }
    });
    return map;
  }

  function findParent(container, parentKey) {
    return container.querySelector('[data-line-key="' + parentKey + '"]:not([data-parent-key])');
  }

  function enforceChildMinOnParent(parentEl, childMin) {
    var input = parentEl.querySelector('input[name="updates[]"]');
    if (input) {
      var currentMin = parseInt(input.min, 10) || 1;
      var effectiveMin = Math.max(currentMin, childMin);
      input.min = effectiveMin;
      if (parseInt(input.value, 10) < effectiveMin) {
        input.value = effectiveMin;
      }
    }

    var links = parentEl.querySelectorAll('line-item-quantity a[href*="cart/change"], line-item-quantity a[href*="cart%2Fchange"]');
    links.forEach(function (link) {
      try {
        var url = new URL(link.href);
        var qty = parseInt(url.searchParams.get('quantity'), 10);
        if (!isNaN(qty) && qty < childMin && qty !== 0) {
          url.searchParams.set('quantity', String(childMin));
          link.href = url.toString();
        }
      } catch (e) { /* ignore malformed URLs */ }
    });
  }

  function showLoader(lineItemEl) {
    var loader = lineItemEl.querySelector('.line-item__loader');
    if (loader) {
      loader.hidden = false;
      var spinner = loader.querySelector('.line-item__loader-spinner');
      if (spinner) spinner.hidden = false;
      var mark = loader.querySelector('.line-item__loader-mark');
      if (mark) mark.hidden = true;
    }
  }

  async function handleSyncedUpdate(parentKey, childKey, quantity, lineItemEl) {
    showLoader(lineItemEl);

    try {
      var parentResponse = await fetch(cartChangeUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parentKey, quantity: quantity })
      });
      if (!parentResponse.ok) throw new Error('Parent update failed');
      await parentResponse.text();

      if (quantity === 0) {
        if (isCartPage) { window.location.reload(); return; }
        var parentCart = JSON.parse(await (await fetch((window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.cartUrl || '/cart') + '.js')).text());
        dispatchCartEvents(parentCart);
        return;
      }

      var childResponse = await fetch(cartChangeUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: childKey, quantity: quantity, sections: ['mini-cart'] })
      });

      if (childResponse.ok) {
        var cartContent = await childResponse.json();

        if (isCartPage) {
          window.location.reload();
          return;
        }

        dispatchCartEvents(cartContent);
      } else {
        window.location.reload();
      }
    } catch (e) {
      console.error('[pacdora-cart] synced update failed:', e);
      window.location.reload();
    }
  }

  function dispatchCartEvents(cartContent) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
      bubbles: true,
      detail: { cart: cartContent }
    }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { cart: cartContent, replacementDelay: 750 }
    }));
  }

  function init(container) {
    var nestedMap = buildNestedMap(container);
    if (nestedMap.size === 0) return;

    nestedMap.forEach(function (childInfo, parentKey) {
      var parentEl = findParent(container, parentKey);
      if (parentEl) {
        enforceChildMinOnParent(parentEl, childInfo.childMin);
      }
    });

    container.addEventListener('click', function (event) {
      var link = event.target.closest('line-item-quantity a');
      if (!link) return;

      var lineItem = link.closest('[data-line-key]');
      if (!lineItem) return;

      var parentKey = lineItem.getAttribute('data-line-key');
      if (lineItem.hasAttribute('data-parent-key')) return;

      var childInfo = nestedMap.get(parentKey);
      if (!childInfo) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var url;
      try { url = new URL(link.href); } catch (e) { return; }
      var newQuantity = parseInt(url.searchParams.get('quantity'), 10);
      if (isNaN(newQuantity)) return;

      if (newQuantity > 0) {
        newQuantity = Math.max(newQuantity, childInfo.childMin);
      }

      handleSyncedUpdate(parentKey, childInfo.childKey, newQuantity, lineItem);
    }, true);

    container.addEventListener('change', function (event) {
      var input = event.target;
      if (input.tagName !== 'INPUT' || !input.hasAttribute('data-line')) return;

      var lineItem = input.closest('[data-line-key]');
      if (!lineItem) return;

      var parentKey = lineItem.getAttribute('data-line-key');
      if (lineItem.hasAttribute('data-parent-key')) return;

      var childInfo = nestedMap.get(parentKey);
      if (!childInfo) return;

      event.stopImmediatePropagation();

      var newQuantity = parseInt(input.value, 10);
      if (isNaN(newQuantity)) return;

      newQuantity = Math.max(newQuantity, childInfo.childMin);
      input.value = newQuantity;

      handleSyncedUpdate(parentKey, childInfo.childKey, newQuantity, lineItem);
    }, true);
  }

  function setup() {
    var miniCart = document.getElementById('mini-cart');
    if (miniCart) init(miniCart);

    var cartTable = document.querySelector('.line-item-table');
    if (cartTable) init(cartTable);

    document.documentElement.addEventListener('cart:refresh', function () {
      setTimeout(function () {
        var mc = document.getElementById('mini-cart');
        if (mc) init(mc);
      }, 1000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
